import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export const Pagination = ({ page, totalPages, onPage }) => {
  if (totalPages <= 1) return null;
  const btn = 'p-2 rounded-md border border-gray-200 disabled:opacity-30 hover:bg-gray-50 transition-colors';
  return (
    <div className="flex flex-wrap items-center justify-center gap-2 mt-12" data-testid="catalogue-pagination">
      <button onClick={() => onPage(page - 1)} disabled={page === 1} className={btn} data-testid="pagination-prev">
        <ChevronLeft className="h-4 w-4" />
      </button>
      {Array.from({ length: totalPages }, (_, i) => i + 1).map((p) => (
        <button
          key={p}
          onClick={() => onPage(p)}
          className={`px-3 py-1.5 rounded-md text-sm font-medium transition-colors ${
            p === page ? 'bg-gray-900 text-white' : 'border border-gray-200 hover:bg-gray-50'
          }`}
          data-testid={`pagination-page-${p}`}
        >
          {p}
        </button>
      ))}
      <button onClick={() => onPage(page + 1)} disabled={page === totalPages} className={btn} data-testid="pagination-next">
        <ChevronRight className="h-4 w-4" />
      </button>
    </div>
  );
};
